export enum NCZI_LAST_STATE {
	EXECUTING = 'executing',
	CREATED = 'created',
	ACCEPTED = 'accepted',
	WAITING_AUTH = 'waitingAuth',
	AUTHORIZED = 'authorized',
	PATIENT_WAITING_AUTH = 'waitingPatientAuth',
	PATIENT_AUTHORIZED = 'patientAuthorized',
	MESSAGE_CREATED = 'messageCreated',
	MESSAGE_RECEIVED = 'messageReceived',
	DONE = 'done',
	ERROR = 'error',
	OFFLINE = 'offline',
	MANUAL = 'manual',
}
